const addDays = (dateInput, days) => {
    var date = new Date(dateInput)
    date.setDate(date.getDate() + days)
    return date
}

export {
    addDays,
}